// Mock implementations for the Square OAuth endpoints
// (contract: docs/superpowers/specs/2026-07-28-square-oauth-connect-design.md §6).
// Connection state persists in localStorage so demos survive a refresh.
// Pure module (no axios) — unit-testable under CRA5 Jest.

import { MOCK_AUTHORIZE_URL } from "./squareUtils";

const STORAGE_KEY = "zoey_square_mock_connection";

const storage = () => (typeof window === "undefined" ? null : window.localStorage);

export const readMockConnection = () => {
  try {
    const raw = storage()?.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch (e) {
    return null;
  }
};

export const mockStatus = () => {
  const connection = readMockConnection();
  return {
    connected: !!connection,
    authorize_url: MOCK_AUTHORIZE_URL,
    connection,
  };
};

export const mockConnect = ({ code } = {}) => {
  if (!code || code === "mock-fail") {
    throw new Error("Square did not authorize the connection. Please try again.");
  }
  const connection = {
    business_name: "3D Lifestyle MedSpa",
    location_name: "Main Location",
    merchant_id: "MLZY8KD2MOCK4M",
    application_key: "sq0idp-ZoeyMockAppId000000000",
    connected_at: new Date().toISOString(),
  };
  try {
    storage()?.setItem(STORAGE_KEY, JSON.stringify(connection));
  } catch (e) {}
  return {
    connection,
    credentials: {
      merchant_id: connection.merchant_id,
      application_key: connection.application_key,
      application_token: "EAAA-mock-oauth-access-token",
    },
  };
};

export const mockDisconnect = () => {
  try {
    storage()?.removeItem(STORAGE_KEY);
  } catch (e) {}
  return true;
};
